import { render, staticRenderFns } from "./ReviewCreatives.vue?vue&type=template&id=1c2f6a10&scoped=true"
import script from "./ReviewCreatives.vue?vue&type=script&lang=js"
export * from "./ReviewCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f6a10",
  null
  
)

export default component.exports